import { render, staticRenderFns } from "./CreatEditModal.vue?vue&type=template&id=c1dc8c76&scoped=true"
import script from "./CreatEditModal.vue?vue&type=script&lang=js"
export * from "./CreatEditModal.vue?vue&type=script&lang=js"
import style0 from "./CreatEditModal.vue?vue&type=style&index=0&id=c1dc8c76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dc8c76",
  null
  
)

export default component.exports